import React, { Component } from 'react';
import { MapNote } from 'vms-base';
import { MapNoteFilter } from '../../components';
import s from './HostStyles.module.scss';

export default class MapNoteFilterHost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totals: { open: 4, resolved: 2 },
            filter: MapNote.MapNoteFilter.fromDefault(),
            showNotesOnMap: true,
            expanded: false,
            otherExpanded: false,
        };
    }

    onButtonClick = () => {
        const { showNotesOnMap } = this.state;
        this.setState({ showNotesOnMap: !showNotesOnMap, expanded: false });
    };

    onFilterClick = () => {
        const { expanded } = this.state;
        this.setState({ expanded: !expanded, showNotesOnMap: true });
    };

    onStatusClick = selectedOption => {
        const { filter } = this.state;
        this.setState({ filter: MapNote.MapNoteFilter.setStatus(selectedOption, filter) });
    };

    onTypeClick = selectedOption => {
        const { filter } = this.state;
        this.setState({ filter: MapNote.MapNoteFilter.toggleType(selectedOption, filter) });
    };

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <MapNoteFilter
                    showNotesOnMap={this.state.showNotesOnMap}
                    expanded={this.state.expanded}
                    otherExpanded={this.state.otherExpanded}
                    onButtonClick={this.onButtonClick}
                    onFilterClick={this.onFilterClick}
                    onStatusClick={this.onStatusClick}
                    onTypeClick={this.onTypeClick}
                    status={this.state.filter.status}
                    type={this.state.filter.type}
                    totals={this.state.totals}
                />
            </div>
        );
    }
}
